import { render, staticRenderFns } from "./PillAlignment.vue?vue&type=template&id=aad07934&"
import script from "./PillAlignment.vue?vue&type=script&lang=js&"
export * from "./PillAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports